import { ru, uk } from "date-fns/locale";

export const localeMap = { ru, uk };
